import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { formatDate } from '../../../../services/functions';
import { SmallFormTextField } from '../../../../components/small-fields/SmallFormTextField';
import { SmallFormDateField } from '../../../../components/small-fields/SmallFormDateField';
import { useSelector } from 'react-redux';
import { SmallPhoneNumberField } from '../../../../components/small-fields/SmallPhoneNumberField';

export const ContactDataForm = props => {
  const {
    formik,
    type,
    name,
    streetAddress,
    postalCode,
    city,
    birthDate,
    nipOrPesel,
    phoneNumber,
    email,
    invoice,
    gender,
    additionalPhone,
    secondGuardianNameAndSurname,
    guardian_pesel = ''
  } = props;
  const { module, seasonYear } = useSelector(state => state.app);
  console.log('module', module);
  console.log('season', seasonYear);

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      mt={1}
    >
      <Stack spacing={1} flex="1 1 50%">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="right"
          spacing={1}
        >
          <Typography variant="subtitle2">Nazwa</Typography>
          <SmallFormTextField
            error={formik.errors[name] && formik.touched[name]}
            name={name}
            placeholder="nazwa"
            value={formik.values[name]}
            onChange={formik.handleChange}
            helperText={formik.errors[name]}
          />
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="right"
          spacing={1}
        >
          <Typography variant="subtitle2">Ulica</Typography>
          <SmallFormTextField
            error={
              formik.errors[streetAddress] && formik.touched[streetAddress]
            }
            name={streetAddress}
            placeholder="ulica"
            value={formik.values[streetAddress]}
            onChange={formik.handleChange}
            helperText={formik.errors[streetAddress]}
          />
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="right"
          spacing={1}
        >
          <Typography variant="subtitle2">Kod pocztowy</Typography>
          <SmallFormTextField
            error={formik.errors[postalCode] && formik.touched[postalCode]}
            name={postalCode}
            placeholder="kod pocztowy"
            value={formik.values[postalCode]}
            onChange={formik.handleChange}
            helperText={formik.errors[postalCode]}
          />
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="right"
          spacing={1}
        >
          <Typography variant="subtitle2">Miejscowość</Typography>
          <SmallFormTextField
            error={formik.errors[city] && formik.touched[city]}
            name={city}
            placeholder="miejscowość"
            value={formik.values[city]}
            onChange={formik.handleChange}
            helperText={formik.errors[city]}
          />
        </Stack>
      </Stack>

      <Stack spacing={1} flex="1 1 50%">
        {type === 'participant' ? (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="right"
            spacing={1}
          >
            <Typography variant="subtitle2">Data urodzenia</Typography>
            <SmallFormDateField
              standardTextField
              name={birthDate}
              id={birthDate}
              type="text"
              placeholder="data urodzenia"
              value={formik.values[birthDate]}
              onChange={val => formik.setFieldValue(birthDate, formatDate(val))}
              error={Boolean(formik.errors[birthDate])}
              helperText={formik.touched[birthDate] && formik.errors[birthDate]}
            />
          </Stack>
        ) : null}
        {type !== 'guardian' ? (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="right"
            spacing={1}
          >
            <Typography variant="subtitle2">
              {type === 'participant' ? 'PESEL' : 'NIP'}
            </Typography>
            <SmallFormTextField
              name={nipOrPesel}
              placeholder={type === 'participant' ? 'pesel' : 'nip'}
              value={formik.values[nipOrPesel]}
              onChange={formik.handleChange}
            />
          </Stack>
        ) : null}
        {type !== 'participant' ? (
          <>
            {module === 'wyjazdy_rodzinne' ? (
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="right"
                spacing={1}
              >
                <Typography variant="subtitle2">Pesel</Typography>
                <SmallFormTextField
                  name={guardian_pesel}
                  placeholder="pesel"
                  value={formik.values[guardian_pesel]}
                  onChange={formik.handleChange}
                />
              </Stack>
            ) : null}
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="right"
              spacing={1}
            >
              <Typography variant="subtitle2">Telefon</Typography>
              {Number(seasonYear) >= 2026 ? (
                <SmallPhoneNumberField
                  name={phoneNumber}
                  placeholder="telefon"
                  value={formik.values[phoneNumber]}
                  onChange={val => formik.setFieldValue(phoneNumber, val)}
                  helperText={formik.errors[email]}
                />
              ) : (
                <SmallFormTextField
                  name={phoneNumber}
                  placeholder="telefon"
                  value={formik.values[phoneNumber]}
                  onChange={formik.handleChange}
                />
              )}
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="right"
              spacing={1}
            >
              <Typography variant="subtitle2">E-mail</Typography>
              <SmallFormTextField
                error={formik.errors[email] && formik.touched[email]}
                name={email}
                placeholder="e-mail"
                value={formik.values[email]}
                onChange={formik.handleChange}
                helperText={formik.errors[email]}
              />
            </Stack>
          </>
        ) : null}
        {type === 'guardian' && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="right"
            spacing={1}
          >
            <Typography variant="subtitle2">Dodatkowy telefon</Typography>
            {Number(seasonYear) >= 2026 ? (
              <SmallPhoneNumberField
                name={additionalPhone}
                placeholder="dodatkowy numer telefonu"
                value={formik.values[additionalPhone]}
                onChange={val => formik.setFieldValue(additionalPhone, val)}
              />
            ) : (
              <SmallFormTextField
                name={additionalPhone}
                value={formik.values[additionalPhone]}
                onChange={formik.handleChange}
                placeholder="dodatkowy numer telefonu"
              />
            )}
          </Stack>
        )}
        {(type === 'guardian' && seasonYear >= 2025) &&
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="right"
          spacing={1}
        >
          <Typography variant="subtitle2" flex="1 1 36%" ml={3}>Imię i nazwisko drugiego opiekuna</Typography>
          <SmallFormTextField
            name={secondGuardianNameAndSurname}
            value={formik.values[secondGuardianNameAndSurname]}
            onChange={formik.handleChange}
            placeholder="imię i nazwisko drugiego opiekuna (opcjnalnie)"
            sx={{ flex: '1 1 64%' }}
            multiline
            rows={2}
          />
        </Stack>}
        {type === 'participant' ? (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="right"
            spacing={1}
          >
            <Typography variant="subtitle2">Płeć</Typography>
            <SmallFormTextField
              select
              name={gender}
              placeholder="płeć"
              options={[
                { value: 'boy', label: 'Chłopiec' },
                { value: 'girl', label: 'Dziewczynka' }
              ]}
              value={formik.values[gender]}
              onChange={formik.handleChange}
            />
          </Stack>
        ) : null}
      </Stack>
    </Box>
  );
};
